import { atom } from "jotai";

export const ethPriceAtom = atom(0);
export const okbPriceAtom = atom(0);
